(() => {
  if (customElements.get('fxl-product-links')) return;
  class FxlProductLinks extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized) return;
      this.dataset.initialized = 'true';
      if (this.dataset.axis === 'color' || this.dataset.axis === 'other') return;
      const list = this.querySelector('[data-linked-list]');
      if (!list) return;
      const items = [...this.querySelectorAll('[data-linked-item]')];
      const search = this.querySelector('[data-linked-search]');
      const status = this.querySelector('[data-linked-results]');
      const fold = text => text.toLocaleLowerCase('nl').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      const terms = items.map(item => fold(item.dataset.search || ''));
      const refresh = () => {
        const words = fold(search?.value.trim() || '').split(/\s+/).filter(Boolean);
        let visible = 0;
        items.forEach((item, i) => {
          item.hidden = !words.every(word => terms[i].includes(word));
          if (!item.hidden) visible++;
        });
        if (status) {
          status.hidden = !words.length;
          status.textContent = visible === 1 && status.dataset.single ? status.dataset.single : (status.dataset.template || 'FXLCOUNT').replace('FXLCOUNT', visible);
        }
        if (words.length) list.scrollLeft = 0;
      };
      search?.addEventListener('input', refresh);
      this.querySelectorAll('[data-linked-direction]').forEach(button => {
        button.addEventListener('click', () => list.scrollBy({left:Number(button.dataset.linkedDirection) * list.clientWidth * .8,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'}));
      });
      requestAnimationFrame(() => {
        if (this.dataset.axis !== 'color') return;
        const current = this.querySelector('[data-linked-current]')?.closest('[data-linked-item]');
        if (current) list.scrollLeft = Math.max(0,current.offsetLeft-list.offsetLeft-(list.clientWidth-current.clientWidth)/2);
      });
    }
  }
  customElements.define('fxl-product-links', FxlProductLinks);
})();



